<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary">
        <v-icon left>mdi-plus-circle</v-icon>
        {{ $t("chat.NewConversationUsers.newChat") }}
      </v-btn>
    </template>

    <v-card>
      <div class="headline primary d-flex justify-space-between align-center">
        <v-card-title class="white--text">
          <span>{{ $t("chat.NewConversationUsers.newChat") }}</span>
        </v-card-title>
        <v-btn icon color="white" class="mr-2" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="travelers"
          hide-default-footer
          show-select
          item-key="id"
          selectable-key="id"
          v-model="selected"
          :items-per-page="100"
          class="elevation-1"
        >
          <template v-slot:[`item.profile_pic`]="{ item }">
            <v-avatar color="grey" size="40" class="my-2">
              <v-img :src="userPic(item.id)"></v-img>
            </v-avatar>
          </template>
        </v-data-table>
        <p v-if="feedback" class="red--text mt-2">{{ feedback }}</p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="createChat">{{ $t("common.create") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      feedback: null,
      selected: [],

      headers: [
        {
          value: "profile_pic",
          width: 30,
        },
        {
          text: this.$i18n.t("common.name"),
          value: "name",
        },
      ],
    };
  },
  computed: {
    travelers() {
      const meId = this.$store.state.firUser.uid;
      return this.$store.getters.allUsers.filter((u) => u.id !== meId);
    },
    selectedIds() {
      return this.selected.map((a) => a.id);
    },
    userId() {
      return this.$store.state.firUser.uid;
    },
    imAdmin() {
      return this.isUserAdmin(this.userId);
    },
  },
  methods: {
    createChat() {
      if (this.selectedIds.length === 0) {
        this.feedback = this.$t("chat.NewConversationUsers.feedback");
        return;
      }

      this.feedback = null;
      this.$emit("users", this.selectedIds);
      this.closeDialog();
    },
    userPic(userId) {
      return (
        this.$store.getters.getImageUrlById(userId) || require("@/assets/profile_pic_empty.png")
      );
    },
    closeDialog() {
      this.selected = [];
      this.dialog = false;
    },
  },
};
</script>
